import { NextRequest, NextResponse } from 'next/server';
import { db } from '@/lib/db';

export async function GET() {
  try {
    console.log('👥 Fetching all users...');
    
    const users = await db.users.getAllUsers();
    
    console.log(`✅ Found ${users.length} users`);
    
    return NextResponse.json({
      success: true,
      users
    });
  } catch (error) {
    console.error('❌ Error fetching users:', error);
    const errorMessage = error instanceof Error ? error.message : 'Unknown error';
    return NextResponse.json(
      { error: 'Failed to fetch users: ' + errorMessage },
      { status: 500 }
    );
  }
}
